
import { createI18n } from 'vue-i18n'
import elementEnLocale from "element-plus/lib/locale/lang/en";
import elementZhLocale from "element-plus/lib/locale/lang/zh-cn";

import enLocale from "./en";
import zhLocale from "./zh";

const messages = {
  "en": {
    ...enLocale, // 英文语言包
    ...elementEnLocale
  },
  "zh": {
    ...zhLocale,
    ...elementZhLocale
  }
}

const i18n = createI18n({
    globalInjection: true,
    legacy: false,
    locale: process.env.VUE_APP_LANG || 'zh', // 设置默认语言
    fallbackLocale: 'zh', // 设置回退语言
    messages, // 设置语言包
    warnHtmlMessage: false
})



export default i18n